import { Reducer } from 'redux';
import { DisbursementPayoutActionTypes } from '../constants/actionTypes';
import {
  IDisbursementPayoutDataAction,
} from '../actions/disbursementPayoutAction';

// Define the initial state
const initialState: IDisbursementPayoutState = {
  isUploaded: false,
  errors: undefined,
};

export interface IDisbursementPayoutState {
  readonly isUploaded: boolean;
  readonly errors: string[] | undefined;
}

export const disbursementPayoutReducer: Reducer<IDisbursementPayoutState,
IDisbursementPayoutDataAction> = (
  state = initialState,
  action: IDisbursementPayoutDataAction,
) => {
  switch (action.type) {
    case DisbursementPayoutActionTypes.CREATE_LOAN_APPLICATION_DISBURSEMENT_PAYOUT:
      return {
        ...state,
        errors: undefined,
        isUploaded: true,
      };
    case DisbursementPayoutActionTypes.ERROR_LOAN_APPLICATION_DISBURSEMENT_PAYOUT:
      return {
        ...state,
        errors: action.errors,
        isUploaded: false,
      };
    case DisbursementPayoutActionTypes.RESET_LOAN_APPLICATION_DISBURSEMENT_PAYOUT:
      return {
        ...state,
        errors: undefined,
        isUploaded: false,
      };
    default:
      return state;
  }
};
